
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"13","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.47 5.97a.75.75 0 000 1.06l4.773 4.773a.75.75 0 101.06-1.06L2.061 6.5l4.242-4.243a.75.75 0 00-1.06-1.06L.47 5.97zM1 7.25h12v-1.5H1v1.5z","fill":"#6362EC"}})])
          )
        }
      }
    